var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 11,
    height: 11,
    stroke: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 5,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 8.5,
    width: 2,
    height: 2,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 2,
    height: 2,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShuffle);
export default __webpack_public_path__ + "static/media/icon-shuffle.22680a20dab2ff160dd12f6156f9ef74.svg";
export { ForwardRef as ReactComponent };